module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app-home ui-styles",
    class: _vm.theme,
    attrs: {
      "id": "marketstudies-index"
    }
  }, [
    [(_vm.master_loading) ? _c('div', {
      staticClass: "loading_view"
    }, [_c('div', {
      staticClass: "view_spinner_container"
    }, [_c('span', {
      staticStyle: {
        "color": "rgb(0, 79, 146)",
        "margin": "0 auto"
      }
    }, [_c('icon', {
      attrs: {
        "name": "spinner",
        "scale": "4",
        "color": "rgb(0, 79, 146)",
        "spin": ""
      }
    })], 1), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('Loading')) + "...")])])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "master_view"
    }, [_c('side-nav-bar', {
      attrs: {
        "bdefilesOpen": _vm.bdefilesOpen
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "app-container"
    }, [_c('bar'), _vm._v(" "), _c('h1', [_vm._v(_vm._s(_vm.$t('BDE_files_index')))]), _vm._v(" "), _c('vue-tabs', [_c('v-tab', {
      attrs: {
        "title": _vm.bdefiles_index_text
      }
    }, [_c('div', {
      staticClass: "tab_content"
    }, [_c('div', [_c('form', {
      staticClass: "bt-form"
    }, [_c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('BDE_files')))]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('ul', _vm._l((this.bdefiles_by_years), function(value, key) {
      return _c('li', {
        staticClass: "listlink",
        on: {
          "click": function($event) {
            _vm.openFilesFromYear(key)
          }
        }
      }, [_vm._v(" " + _vm._s(key) + "\n\t\t\t\t\t\t\t\t\t\t\t\t")])
    }))])])])])])])], 1), _vm._v(" "), _c('bar')], 1)], 1)]
  ], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2dda5de8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/app/bdefiles/BdefilesIndex.vue
// module id = 2125
// module chunks = 0